class CategoryShowcaseReveal extends HTMLElement {
  constructor() {
    super();
    this.animation = null;
    this.fallbackTimer = null;
  }

  connectedCallback() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      this.showFallback();
      return;
    }

    if (document.readyState === 'complete') {
      this.init();
    } else {
      window.addEventListener('load', () => this.init());
    }

    /* Safety fallback — reveal after 5s only if GSAP never initialises */
    this.fallbackTimer = setTimeout(() => this.showFallback(), 5000);
  }

  getGSAP() {
    if (typeof window !== 'undefined' && window.gsap && typeof window.gsap.to === 'function') {
      return window.gsap;
    }
    if (typeof window !== 'undefined' && window.GSAP && typeof window.GSAP.to === 'function') {
      return window.GSAP;
    }
    if (typeof window !== 'undefined' && window.GreenSockGlobals && window.GreenSockGlobals.gsap) {
      return window.GreenSockGlobals.gsap;
    }
    if (typeof gsap !== 'undefined' && typeof gsap.to === 'function') {
      return gsap;
    }
    return null;
  }

  waitForGSAP() {
    return new Promise((resolve) => {
      if (this.getGSAP()) {
        resolve();
        return;
      }

      /* Poll for GSAP availability — CDN defer scripts may not have executed yet */
      var attempts = 0;
      var check = setInterval(() => {
        attempts++;
        if (this.getGSAP() || attempts > 50) {
          clearInterval(check);
          resolve();
        }
      }, 100);
    });
  }

  async init() {
    await this.waitForGSAP();
    const gsapLib = this.getGSAP();

    if (!gsapLib) {
      this.showFallback();
      return;
    }

    /* GSAP loaded — cancel the safety fallback so it doesn't interfere */
    if (this.fallbackTimer) {
      clearTimeout(this.fallbackTimer);
      this.fallbackTimer = null;
    }

    var sectionId = this.getAttribute('data-section-id');
    var section = document.getElementById('CategoryShowcase-' + sectionId);
    if (!section) return;

    var grid = section.querySelector('.category-showcase__grid');
    if (!grid) return;

    var items = section.querySelectorAll('.category-showcase__item');
    if (!items.length) {
      this.showFallback();
      return;
    }

    var hasScrollTrigger = typeof ScrollTrigger !== 'undefined' ||
                          (gsapLib.plugins && gsapLib.plugins.scrollTrigger);

    if (hasScrollTrigger && gsapLib.registerPlugin) {
      try {
        gsapLib.registerPlugin(ScrollTrigger || gsapLib.plugins.scrollTrigger);
      } catch (e) {
        // ScrollTrigger already registered
      }
    }

    var animConfig = {
      opacity: 1,
      y: 0,
      scale: 1,
      duration: 0.7,
      stagger: 0.15,
      ease: 'power3.out'
    };

    if (hasScrollTrigger) {
      animConfig.scrollTrigger = {
        trigger: grid,
        start: 'top 80%',
        once: true
      };
    }

    this.animation = gsapLib.fromTo(items,
      { opacity: 0, y: 50, scale: 0.95 },
      animConfig
    );

    /* Fallback: use IntersectionObserver if ScrollTrigger is not available */
    if (!hasScrollTrigger) {
      var self = this;
      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            if (self.animation && self.animation.play) self.animation.play();
            observer.disconnect();
          }
        });
      }, { threshold: 0.2 });
      observer.observe(grid);
    }
  }

  showFallback() {
    var sectionId = this.getAttribute('data-section-id');
    var section = document.getElementById('CategoryShowcase-' + sectionId);
    if (!section) return;

    if (this.animation && this.animation.kill) {
      this.animation.kill();
    }

    var items = section.querySelectorAll('.category-showcase__item');
    items.forEach(function(el) {
      el.style.opacity = '1';
      el.style.transform = 'none';
    });
  }

  disconnectedCallback() {
    if (this.animation) {
      if (this.animation.scrollTrigger) this.animation.scrollTrigger.kill();
      if (this.animation.kill) this.animation.kill();
    }
  }
}

if (!customElements.get('category-showcase-reveal')) {
  customElements.define('category-showcase-reveal', CategoryShowcaseReveal);
}


